<div class="lum-modal">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">{{
      mode === 'Create' ? 'Add Variant SKU' : 'Update Variant SKU'
    }}</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <div class="rfq-variants__wrapper">
      <form [formGroup]="form">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Search Parent SKU</label>
              <input
                type="text"
                placeholder="Search for parent SKU or Product"
                [value]="displayValue"
                matInput
                class="lum-input"
                (input)="onSearchKeywordChange($event)"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFn"
                (optionSelected)="onSelectOption($event)"
              >
                <ng-container *ngIf="!(loading$ | async) || false; else loader">
                  <mat-option *ngFor="let rfq of rfqs" [value]="rfq">
                    {{ rfq?.internal_sku || rfq?.sku }} [{{ rfq?.product_name }}]
                  </mat-option>
                </ng-container>
                <ng-template #loader>
                  <mat-option>
                    <div class="flex gap-4">
                      <mat-progress-spinner
                        class="progress-spinner mt-3"
                        diameter="24"
                        mode="indeterminate"
                      ></mat-progress-spinner>
                      <small>Loading...</small>
                    </div>
                  </mat-option>
                </ng-template>
              </mat-autocomplete>
            </div>
          </div>
          <ng-container *ngIf="variantParentIdControl.value">
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Variant SKU</label>
                <input
                  type="text"
                  class="lum-input"
                  formControlName="internal_sku"
                />
                <mat-error
                  *ngIf="internalSkuControl && internalSkuControl.invalid"
                  >{{ internalSkuControl | validateField }}</mat-error
                >
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="">Product Name</label>
                <input
                  type="text"
                  class="lum-input"
                  formControlName="product_name"
                />
                <mat-error
                  *ngIf="productNameControl && productNameControl.invalid"
                  >{{ productNameControl | validateField }}</mat-error
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Wholesale Price</label>
                <input
                  type="text"
                  class="lum-input"
                  formControlName="wholesale_price"
                />
                <mat-error
                  *ngIf="wholeSalePriceControl && wholeSalePriceControl.invalid"
                  >{{ wholeSalePriceControl | validateField }}</mat-error
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Retail Price</label>
                <input
                  type="text"
                  class="lum-input"
                  formControlName="retail_price"
                />
                <mat-error
                  *ngIf="retailPriceControl && retailPriceControl.invalid"
                  >{{ retailPriceControl | validateField }}</mat-error
                >
              </div>
            </div>
          </ng-container>
        </div>
      </form>
    </div>
  </div>
  <div class="lum-modal__footer mt-4 w-p100" mat-dialog-actions>
    <div class="flex ml-auto lum-modal__action">
      <button
        type="button"
        class="lum-button lum-button--secondary mr-2"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          icon="close"
          color="#5563D6"
          width="16"
          height="16"
        ></lum-ui-icon>
        Close
      </button>

      <lum-ui-button
        [disabled]="(submittingForm$ | async) || hasInvalidInput || false"
        [loading]="(submittingForm$ | async) || false"
        (clickEvent)="onSubmit()"
      >
        <lum-ui-icon
          class="mr-2.5"
          icon="files"
          color="#ffffff"
          width="16"
          height="16"
        ></lum-ui-icon>
        Save
      </lum-ui-button>
    </div>
  </div>
</div>
